import { useTranslationMipMessages } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { INVESTOR_MESSAGES_TEST_ID } from '@dealstack/shared/tests/testElementIds';
import { EmptyState } from '@dealstack/frontend/shared/components/EmptyState/EmptyState.tsx';

export const MessagesListEmpty = () => {
	const tMipMessages = useTranslationMipMessages();

	return (
		<EmptyState
			dataTestId={INVESTOR_MESSAGES_TEST_ID.MESSAGE_LIST_EMPTY}
			description={tMipMessages('list.empty')}
			icon="es-flying-paper"
			iconSize="sm"
		/>
	);
};
